import { GET_ALL_OWNER } from "helpers/url_helper";
import { ADD_PARTICULAR_OWNER, ADD_PARTICULAR_OWNER_FAIL, ADD_PARTICULAR_OWNER_SUCCESS, GET_ALL_OWNER_FAIL, GET_ALL_OWNER_SUCCESS, GET_ALL_PARTICULAR_OWNER, GET_ALL_PARTICULAR_OWNER_FAIL, GET_ALL_PARTICULAR_OWNER_SUCCESS, GET_PARTICULAR_OWNER, GET_PARTICULAR_OWNER_FAIL, GET_PARTICULAR_OWNER_SUCCESS, GET_TOP_SALES, GET_TOP_SALES_FAIL, GET_TOP_SALES_SUCCESS, GET_VIEW_COUNT_OWNER, GET_VIEW_COUNT_OWNER_FAIL, GET_VIEW_COUNT_OWNER_SUCCESS, LIKE_VIEW_OWNER, LIKE_VIEW_OWNER_FAIL, LIKE_VIEW_OWNER_SUCCESS, UPDATE_PARTICULAR_OWNER, UPDATE_PARTICULAR_OWNER_FAIL, UPDATE_PARTICULAR_OWNER_SUCCESS } from "./actionType";

export const getParticularOwner = (data, callback) => ({
    type: GET_PARTICULAR_OWNER ,
    payload: {data, callback},
  });
  export const getParticularOwnerSuccess = (data) => ( {
  
    type: GET_PARTICULAR_OWNER_SUCCESS,
    payload: data,
  });
  export const getParticularOwnerFail = (error) => ({
    type: GET_PARTICULAR_OWNER_FAIL,
    payload: error,
  });


  export const addParticularOwner = (data,callback) => ({
    type: ADD_PARTICULAR_OWNER ,
    payload: {data,callback}
  });
  export const addParticularOwnerSuccess = (data) => ({
    type: ADD_PARTICULAR_OWNER_SUCCESS,
    payload: data,
  });
  export const addParticularOwnerFail = (error) => ({
    type: ADD_PARTICULAR_OWNER_FAIL,
    payload: error,
  });


  export const updateParticularOwner = (data) => ({
    type: UPDATE_PARTICULAR_OWNER ,
    payload: data,
  });
  export const updateParticularOwnerSuccess = (data) => ({
    type: UPDATE_PARTICULAR_OWNER_SUCCESS,
    payload: data,
  });
  export const updateParticularOwnerFail = (error) => ({
    type: UPDATE_PARTICULAR_OWNER_FAIL,
    payload: error,
  });

  

  export const getAllParticularOwner = (data, callback) => ( {
    type: GET_ALL_OWNER ,
    payload:{data, callback},
  });
  export const getAllParticularOwnerSuccess = (data, callback) => ({
    type: GET_ALL_OWNER_SUCCESS,
    payload: {data, callback},
  });
  export const getAllParticularOwnerFail = (error) => ({
    type: GET_ALL_OWNER_FAIL,
    payload: error,
  });


  export const getviewCountOwner = (id, callback) => ({
    type: GET_VIEW_COUNT_OWNER ,
    payload: {id, callback},
  });
  export const getviewCountOwnerSuccess = (data) => ({
    type: GET_VIEW_COUNT_OWNER_SUCCESS,
    payload: data,
  });
  export const getviewCountOwnerFail = (error) => ({
    type: GET_VIEW_COUNT_OWNER_FAIL,
    payload: error,
  });


  export const likeViewOwner = (data, callback) => ({
    type: LIKE_VIEW_OWNER ,
    payload: {data, callback},
  });
  export const likeViewOwnerSuccess = (data) => ({
    type: LIKE_VIEW_OWNER_SUCCESS,
    payload: data,
  });
  export const likeViewOwnerFail = (error) => ({
    type: LIKE_VIEW_OWNER_FAIL,
    payload: error,
  });

  export const getTopSales = (data, callback) => ({
    type: GET_TOP_SALES ,
    payload: {data, callback},
  });
  export const getTopSalesSuccess = (data) => ({
    type: GET_TOP_SALES_SUCCESS,
    payload: data,
  });
  export const getTopSalesFail = (error) => ({
    type: GET_TOP_SALES_FAIL,
    payload: error,
  });